export default "__VITE_ASSET__B5NY_IVa__"